import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { Button } from '@vk-hr-tek/ui/Button';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Dialog, DialogContent } from '@vk-hr-tek/ui/Dialog';
import { Descriptions, DescriptionsItem } from '@vk-hr-tek/ui/Descriptions';

import { ContentSurveysFormValues } from '../../types';

interface DeleteContentSurveysDialogProps {
  isOpen: boolean;
  onClose: VoidFunction;
  onDelete: VoidFunction;
  contentSurvey: ContentSurveysFormValues | null;
}

export const DeleteContentSurveysDialog = ({
  isOpen,
  onClose,
  onDelete,
  contentSurvey,
}: DeleteContentSurveysDialogProps) => {
  if (!contentSurvey) return null;

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent
        onClose={onClose}
        title="Удаление опроса"
        actions={
          <>
            <Button size="large" onClick={onClose} variant="tertiaryLight">
              Отменить
            </Button>

            <Button
              size="large"
              type="submit"
              variant="warning"
              onClick={onDelete}
            >
              Удалить
            </Button>
          </>
        }
      >
        <Box display="flex" flexDirection="column" gap="16">
          <Typography variant="body1" color="text.light.secondary">
            Вы уверены, что хотите удалить опрос?
          </Typography>

          <Descriptions>
            <DescriptionsItem
              label="Название опроса"
              value={contentSurvey.common.name}
            />
            <DescriptionsItem
              label="Дата завершения"
              value={
                contentSurvey.settings.completionDate
                  ? [
                      contentSurvey.settings.completionDate,
                      contentSurvey.settings.completionTime,
                    ].join(' ')
                  : 'Срок не ограничен'
              }
            />
          </Descriptions>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
